
export class FermeturePonctuelleFilter {
  idUniteProduction: number;
  perimetre: string;
  dateDebut: string;
  dateFin: string;
  idWorkflowInstance: number;
}
